export default __webpack_public_path__ + "static/media/undraw_events_2p66.e4bbb339.svg";